(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["floating-help-popup"] && !Shopify.designMode) return;
  try {
    
    (() => {
      const roots = document.querySelectorAll('[data-floating-help]');

      const getGorgiasChatInit = () => {
        if (window.GorgiasChat && typeof window.GorgiasChat.init === 'function') {
          return window.GorgiasChat.init();
        }

        if (window.__floatingHelpGorgiasInitPromise) {
          return window.__floatingHelpGorgiasInitPromise;
        }

        window.__floatingHelpGorgiasInitPromise = new Promise((resolve) => {
          window.addEventListener('gorgias-widget-loaded', () => resolve(), { once: true });
        });

        return window.__floatingHelpGorgiasInitPromise;
      };

      const getGorgiasLauncher = () => {
        return document.querySelector('#gorgias-chat-container #chat-button') || document.querySelector('#chat-button');
      };

      const setGorgiasLauncherVisible = (isVisible) => {
        const launcher = getGorgiasLauncher();

        if (!launcher) {
          return false;
        }

        launcher.style.display = isVisible ? '' : 'none';
        return true;
      };

      const waitForGorgiasLauncher = (isVisible) => {
        let attempts = 0;

        const timer = window.setInterval(() => {
          attempts += 1;

          if (setGorgiasLauncherVisible(isVisible) || attempts >= 80) {
            window.clearInterval(timer);
          }
        }, 50);
      };

      const observeGorgiasLauncher = (root) => {
        if (root.dataset.gorgiasLauncherObserver === 'true' || typeof window.MutationObserver !== 'function') {
          return;
        }

        root.dataset.gorgiasLauncherObserver = 'true';

        const observer = new MutationObserver(() => {
          setGorgiasLauncherVisible(root.classList.contains('floating-help--gorgias-open'));
        });

        observer.observe(document.body, { childList: true, subtree: true });
      };
  
      for (const root of roots) {
        if (root.dataset.initialized === 'true') {
          continue;
        }
  
        root.dataset.initialized = 'true';
  
        const panel = root.querySelector('.floating-help__panel');
        const toggle = root.querySelector('.floating-help__toggle');
        const closeButton = root.querySelector('.floating-help__close');
        const gorgiasChatTriggers = root.querySelectorAll('[data-gorgias-chat-trigger]');
  
        if (!panel || !toggle || !closeButton) {
          continue;
        }
  
        const setOpen = (isOpen) => {
          panel.classList.toggle('is-open', isOpen);
          panel.setAttribute('aria-hidden', String(!isOpen));
          toggle.setAttribute('aria-expanded', String(isOpen));
          toggle.setAttribute('aria-label', isOpen ? 'Cerrar panel de ayuda' : 'Abrir panel de ayuda');
        };

        const setGorgiasChatOpen = (isOpen) => {
          root.classList.toggle('floating-help--gorgias-open', isOpen);
          waitForGorgiasLauncher(isOpen);

          if (isOpen) {
            setOpen(false);
          }
        };

        const syncGorgiasChatState = () => {
          if (window.GorgiasChat && typeof window.GorgiasChat.isOpen === 'function') {
            setGorgiasChatOpen(window.GorgiasChat.isOpen());
            return;
          }

          setGorgiasChatOpen(false);
        };
  
        toggle.addEventListener('click', () => {
          setOpen(!panel.classList.contains('is-open'));
        });
  
        closeButton.addEventListener('click', () => {
          setOpen(false);
        });

        for (const trigger of gorgiasChatTriggers) {
          trigger.addEventListener('click', async () => {
            setOpen(false);

            try {
              await getGorgiasChatInit();
              if (window.GorgiasChat && typeof window.GorgiasChat.open === 'function') {
                window.GorgiasChat.open();
                setGorgiasChatOpen(true);
              }
            } catch (error) {
              /* Gorgias is unavailable on this page. */
            }
          });
        }

        getGorgiasChatInit()
          .then(() => {
            syncGorgiasChatState();

            if (window.GorgiasChat && typeof window.GorgiasChat.on === 'function') {
              window.GorgiasChat.on('widget:opened', () => setGorgiasChatOpen(true));
              window.GorgiasChat.on('widget:closed', () => setGorgiasChatOpen(false));
            }
          })
          .catch(() => {
            /* Gorgias is unavailable on this page. */
          });

        observeGorgiasLauncher(root);
  
        document.addEventListener('click', (event) => {
          if (!root.contains(event.target)) {
            setOpen(false);
          }
        });
  
        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') {
            setOpen(false);
          }
        });
      }
  
      if (!document.querySelector('[data-floating-help][data-has-lucide="true"]')) {
        return;
      }
  
      const loadLucide = () => {
        if (window.lucide && typeof window.lucide.createIcons === 'function') {
          return Promise.resolve(window.lucide);
        }
  
        if (window.__floatingHelpLucidePromise) {
          return window.__floatingHelpLucidePromise;
        }
  
        window.__floatingHelpLucidePromise = new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = 'https://unpkg.com/lucide@latest';
          script.async = true;
          script.onload = () => resolve(window.lucide);
          script.onerror = reject;
          document.head.appendChild(script);
        });
  
        return window.__floatingHelpLucidePromise;
      };
  
      loadLucide()
        .then((lucide) => {
          if (lucide && typeof lucide.createIcons === 'function') {
            lucide.createIcons({ attrs: { width: 24, height: 24 } });
          }
        })
        .catch(() => {
          /* no-op */
        });
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);

      // Dynamically set --switch-bar-height from the actual announcement bar height
      const announcementBar = document.querySelector('.announcement-bar-section');
      if (announcementBar) {
        const abHeight = announcementBar.offsetHeight;
        document.documentElement.style.setProperty('--switch-bar-height', `${abHeight}px`);

        // Watch for height changes (e.g. font size adjustments)
        if (!this._abResizeObserver) {
          this._abResizeObserver = new ResizeObserver(() => {
            const h = announcementBar.offsetHeight;
            document.documentElement.style.setProperty('--switch-bar-height', `${h}px`);
          });
          this._abResizeObserver.observe(announcementBar);
        }
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      // Keep inline search always open
      const inlineSearch = this.header.querySelector('.header__search-wrapper .header__search details');
      if (inlineSearch) return;

      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quiz-modal"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-quiz-root]');

    for (const root of roots) {
      if (root.dataset.initialized === 'true') continue;
      root.dataset.initialized = 'true';

      const steps = Array.from(root.querySelectorAll('[data-quiz-step]'));
      const nav = root.querySelector('[data-quiz-nav]');
      const backButton = root.querySelector('[data-quiz-back]');
      const nextButton = root.querySelector('[data-quiz-next]');
      const progressFill = root.querySelector('[data-quiz-progress-fill]');
      const progressLabel = root.querySelector('[data-quiz-progress-label]');
      const questionSteps = steps.filter((step) => !step.classList.contains('quiz-modal__step--result'));
      const emailInput = root.querySelector('[data-quiz-email]');
      const nameInput = root.querySelector('[data-quiz-name]');
      const errorMessage = root.querySelector('[data-quiz-error]');
      const submitButton = root.querySelector('[data-quiz-submit]');
      const leadPanel = root.querySelector('[data-quiz-lead]');
      const resultPanel = root.querySelector('[data-quiz-result]');
      const copyButton = root.querySelector('[data-quiz-copy]');
      const discountCodeEl = root.querySelector('[data-quiz-discount-code]');
      const ctaLinks = Array.from(root.querySelectorAll('[data-quiz-cta]'));
      const baseCollectionUrl = (ctaLinks[0] && ctaLinks[0].getAttribute('href')) || '/collections/all';
      const klaviyoListId = root.dataset.klaviyoListId || '';

      let currentIndex = 1;

      const stepByIndex = (index) => steps.find((step) => Number(step.dataset.stepIndex) === index);

      const isStepValid = (step) => {
        if (!step || step.dataset.required === 'false') return true;
        return step.querySelectorAll('[data-quiz-option][aria-pressed="true"]').length > 0;
      };

      const updateNav = () => {
        const step = stepByIndex(currentIndex);
        const isResultStep = step && step.classList.contains('quiz-modal__step--result');

        backButton.hidden = currentIndex === 1;
        nav.style.display = isResultStep ? 'none' : '';
        nextButton.disabled = !isStepValid(step);
      };

      const updateProgress = () => {
        const total = questionSteps.length;
        const current = Math.min(currentIndex, total);
        progressFill.style.width = `${total ? (current / total) * 100 : 0}%`;
        progressLabel.textContent = currentIndex > total ? 'Último paso' : `Pregunta ${current} de ${total}`;
      };

      const goToStep = (index) => {
        currentIndex = index;
        for (const step of steps) {
          step.classList.toggle('is-active', Number(step.dataset.stepIndex) === index);
        }
        updateNav();
        updateProgress();

        const step = stepByIndex(index);
        if (step && step.classList.contains('quiz-modal__step--result')) {
          updateCtaLinks();
        }
      };

      root.querySelectorAll('[data-quiz-option]').forEach((option) => {
        option.addEventListener('click', () => {
          const step = option.closest('[data-quiz-step]');
          const isSelected = option.getAttribute('aria-pressed') === 'true';

          if (step.dataset.selectionType !== 'multiple') {
            step.querySelectorAll('[data-quiz-option]').forEach((sibling) => sibling.setAttribute('aria-pressed', 'false'));
          }

          option.setAttribute('aria-pressed', String(!isSelected));
          updateNav();
        });
      });

      nextButton.addEventListener('click', () => {
        if (nextButton.disabled) return;
        goToStep(currentIndex + 1);
      });

      backButton.addEventListener('click', () => {
        goToStep(currentIndex - 1);
      });

      const buildResultUrl = () => {
        const params = new URLSearchParams();

        root.querySelectorAll('[data-quiz-option][aria-pressed="true"]').forEach((option) => {
          const filterKey = option.dataset.filterKey;
          const filterValue = option.dataset.filterValue;

          if (!filterKey || !filterValue) return;

          if (filterKey === 'variant_option') {
            const optionName = option.dataset.filterOptionName;
            if (!optionName) return;
            params.append(`filter.v.option.${optionName}`, filterValue);
          } else {
            params.append(`filter.p.${filterKey}`, filterValue);
          }
        });

        const query = params.toString();
        return query ? `${baseCollectionUrl}?${query}` : baseCollectionUrl;
      };

      const updateCtaLinks = () => {
        const url = buildResultUrl();
        ctaLinks.forEach((link) => link.setAttribute('href', url));
      };

      const sendToKlaviyo = (email, name) => {
        if (!klaviyoListId) return;

        const formData = new URLSearchParams();
        formData.append('g', klaviyoListId);
        formData.append('email', email);
        formData.append('$source', 'Quiz Modal');
        if (name) formData.append('$first_name', name);

        const answersByQuestion = new Map();
        root.querySelectorAll('[data-quiz-option][aria-pressed="true"]').forEach((option) => {
          const question = option.dataset.questionTitle;
          const label = option.dataset.label;
          if (!answersByQuestion.has(question)) answersByQuestion.set(question, []);
          answersByQuestion.get(question).push(label);
        });
        answersByQuestion.forEach((labels, question) => formData.append(question, labels.join(', ')));

        fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: formData.toString(),
        }).catch((error) => {
          console.error('Klaviyo error:', error);
        });
      };

      submitButton.addEventListener('click', () => {
        const email = emailInput.value.trim();
        const name = nameInput.value.trim();
        const emailRegex = /^([a-zA-Z0-9_.+-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;

        errorMessage.hidden = true;

        if (!emailRegex.test(email)) {
          errorMessage.textContent = 'Por favor ingresa un correo válido';
          errorMessage.hidden = false;
          return;
        }

        updateCtaLinks();
        // El código y el link a la colección se muestran de inmediato: no dependen
        // de que la llamada a Klaviyo tenga éxito (mejor esfuerzo, sin bloquear la UI).
        sendToKlaviyo(email, name);

        leadPanel.hidden = true;
        resultPanel.hidden = false;
      });

      if (copyButton) {
        copyButton.addEventListener('click', () => {
          navigator.clipboard.writeText(discountCodeEl.textContent.trim()).then(() => {
            const original = copyButton.textContent;
            copyButton.textContent = '¡Copiado!';
            setTimeout(() => {
              copyButton.textContent = original;
            }, 2000);
          });
        });
      }

      if (root.tagName.toLowerCase() === 'modal-dialog') {
        document.body.addEventListener('modalClosed', () => {
          if (root.hasAttribute('open')) return;

          goToStep(1);
          root.querySelectorAll('[data-quiz-option][aria-pressed="true"]').forEach((option) => option.setAttribute('aria-pressed', 'false'));
          emailInput.value = '';
          nameInput.value = '';
          errorMessage.hidden = true;
          leadPanel.hidden = false;
          resultPanel.hidden = true;
        });
      }

      goToStep(1);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
